// OwnerShopsStatus.jsx — Dashboard B2B owner : qui est en ligne / hors ligne
// (Décision owner 2026-07-08 — visibilité temps réel des boutiques mini-site.)
import React, { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL || "";

export default function OwnerShopsStatus() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const load = () => {
      const token = localStorage.getItem("civ_user_token");
      fetch(`${API}/api/v3/admin/minisites/status`, { headers: { Authorization: `Bearer ${token}` } })
        .then((r) => r.json())
        .then((d) => { if (d.ok) setData(d); })
        .catch(() => {});
    };
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  if (!data) return null;

  return (
    <div data-testid="owner-shops-status" style={{
      background: "rgba(6,40,30,0.55)", border: "1px solid rgba(232,213,163,0.45)",
      borderRadius: 12, padding: "12px 14px", color: "#EBD9A8",
    }}>
      <div style={{ fontSize: 13, fontWeight: 800, marginBottom: 6 }}>
        🏬 Boutiques mini-site — <span style={{ color: "#34D399" }}>{data.online_count} en ligne</span>
        <span style={{ color: "rgba(244,241,232,0.5)", fontWeight: 600 }}> / {data.count}</span>
      </div>
      {(data.shops || []).slice(0, 8).map((s) => (
        <div key={s.slug} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 12, padding: "4px 0", color: "#F4F1E8" }}>
          <span>{s.online ? "🟢" : "⚪"}</span>
          <a href={`/commercant/${s.slug}`} style={{ color: "#F4F1E8", fontWeight: 700, textDecoration: "none", flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {s.name}
          </a>
          <span style={{ fontSize: 10, color: "rgba(244,241,232,0.5)" }}>{s.activity} · {s.products_count} produit{s.products_count > 1 ? "s" : ""}</span>
        </div>
      ))}
    </div>
  );
}
